import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import api from "@/api";
import { upperFirst, camelCase } from "lodash";
import { cookies } from "@/plugins/cookie";

Vue.config.productionTip = false;

// 将api挂载到vue的原型上复制代码
Vue.prototype.$cookies = cookies;
Vue.prototype.$api = (module, method, params) => {
  return api[module][method](params);
};

//全局混入
Vue.mixin({
  methods: {
    //路由定向方法
    redirectByPath(path, query) {
      this.$router.push({
        path,
        query
      });
    }
  }
});

// 自动化全局注册
const requireComponent = require.context(
  // 其组件目录的相对路径
  "../components",
  // 是否查询其子目录
  true,
  // 匹配基础组件文件名的正则表达式
  /\w+\.(vue|js)$/
);
requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName);

  // 获取组件的 PascalCase 命名
  const componentName = upperFirst(
    camelCase(
      // 获取和目录深度有关的文件名
      fileName
        .split("/")
        .slice(1)
        .join("_")
        .replace(/\.\w+$/, "")
    )
  );

  // 全局注册组件
  Vue.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    componentConfig.default || componentConfig
  );
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
